import '@vanilla-extract/css/vanilla.virtual.css?ve-css=Ll8xNnNsbGliMCB7CiAgd2lkdGg6IDg4cHg7CiAgaGVpZ2h0OiA0NHB4OwogIHBvc2l0aW9uOiByZWxhdGl2ZTsKfQ';
import '@vanilla-extract/css/vanilla.virtual.css?ve-css=Ll8xNnNsbGliMSB7CiAgd2lkdGg6IDg4cHg7Cn0';
export var wrapperStyle = '_16sllib0';
export var svgStyle = '_16sllib1';